import {
  Dic
} from '$utils'
export const tableOption = function (that) {
  // let deviceMarkList = []
  // Dic.find('SENU087').map(item => {
  //   if (item.value == '27' || item.value == '28' || item.value == '29') {
  //     deviceMarkList.push(item)
  //   }
  // })
  return {
    add: '新增',
    edit: '修改',
    view: '详情',
    emptyText: that.$t("deviceAccess.message.nodata"),
    stripe: true,
    maxHeight: "100%",
    page: true,
    align: "left",
    menuAlign: "center",
    labelSuffix: '：',
    header: false,
    selection: true,
    delBtn: false,
    editBtn: false,
    labelWidth: '120px',
    dialogWidth: '1000px',
    column: [{
      label: '设备名称',
      prop: "thirdDeviceName",
      overHidden: true,
      search: true,
      addDisplay: true,
      editDisplay: true,
      span: 8,
      viewDisplay: true,
      editDisabled: true,
      rules: [{
        required: true,
        message: '请输入',
        trigger: 'blur'
      }],
    },
    {
      label: '第三方设备ID',
      prop: "thirdDeviceId",
      overHidden: true,
      addDisplay: true,
      editDisplay: false,
      span: 8,
      viewDisplay: true,
      rules: [{
        required: true,
        message: '请输入',
        trigger: 'blur'
      }],
    },
    {
      label: "设备状态",
      prop: "status",
      search: true,
      overHidden: true,
      addDisplay: true,
      span: 8,
      viewDisplay: true,
      type: 'select',
      dicData: [
        {
          label: '故障',
          value: '2'
        },
        {
          label: '在线',
          value: '1'
        },
        {
          label: '离线',
          value: '0'
        }
      ],
      formatter: function (row, value) {
        return Number(value) === 1 ? '在线' : Number(value) === 2 ? '故障' : "离线"
      },
      viewFormatter: (row, value) => {
        return Number(value) === 1 ? '在线' : Number(value) === 2 ? '故障' : "离线"
      },
      rules: [{
        required: true,
        message: '请选择',
        trigger: 'blur'
      }],
    },
    {
      label: "是否室内",
      prop: "isIndoor",
      search: true,
      overHidden: true,
      addDisplay: true,
      span: 8,
      viewDisplay: true,
      type: 'select',
      dicData: [{
        label: '是',
        value: '1'
      },
      {
        label: '否',
        value: '0'
      }
      ],
      formatter: function (row, value) {
        return Number(value) === 1 ? '室内' : '室外'
      },
      viewFormatter: (row, value) => {
        return Number(value) === 1 ? '室内' : '室外'
      },
      rules: [{
        required: true,
        message: '请选择',
        trigger: 'blur'
      }],
    },
    {
      label: '所属楼栋',
      prop: "buildingName",
      overHidden: true,
      addDisplay: true,
      span: 8,
      viewDisplay: true,
      rules: [{
        required: true,
        message: '请输入所属楼栋',
        trigger: 'blur'
      }]
    },
    {
      label: '经度',
      prop: "latitude",
      overHidden: true,
      addDisplay: true,
      span: 8,
      viewDisplay: true,
      rules: [{
        required: true,
        message: '请输入',
        trigger: 'blur'
      }]
    },
    {
      label: '纬度',
      prop: "longitude",
      overHidden: true,
      span: 8,
      addDisplay: true,
      viewDisplay: true,
      rules: [{
        required: true,
        message: '请输入',
        trigger: 'blur'
      }]
    },
    {
      label: "横坐标",
      prop: 'abscissa',
      labelWidth: 100,
      disabled: true,
      placeholder: ' ',
      span: 8,
    },
    {
      label: "纵坐标",
      prop: 'ordinate',
      labelWidth: 100,
      disabled: true,
      placeholder: '',
      span: 8,
    },
    {
      label: "厂商名称",
      prop: 'zBusinessName',
      labelWidth: 100,
      span: 8,
      hide: true,
      placeholder: '请输入 '
    },
    {
      label: "设备类型",
      prop: 'zDeviceType',
      span: 8,
      hide: true,
      labelWidth: 100,
      placeholder: '请输入 '
    },
    {
      label: "固件版本",
      prop: 'zGVersion',
      span: 8,
      hide: true,
      labelWidth: 100,
      placeholder: '请输入 '
    },
    // {
    //   label: "软件版本",
    //   prop: 'zSVersion',
    //   span: 8,
    //   hide: true,
    //   labelWidth: 100,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "信号强度",
    //   prop: 'zSmeter',
    //   span: 8,
    //   hide: true,
    //   viewDisplay: true,
    //   labelWidth: 100,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "小区IDinteger",
    //   prop: 'zIDinteger',
    //   span: 8,
    //   hide: true,
    //   labelWidth: 100,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "接收信号强度",
    //   prop: 'zJmeter',
    //   labelWidth: 100,
    //   span: 8,
    //   hide: true,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "接收信号强度",
    //   prop: 'zJmeter',
    //   labelWidth: 100,
    //   span: 8,
    //   hide: true,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "信噪比",
    //   prop: 'zSnr',
    //   span: 8,
    //   hide: true,
    //   labelWidth: 100,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "信号发射强度",
    //   prop: 'zFmeter',
    //   span: 8,
    //   hide: true,
    //   labelWidth: 100,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "小区覆盖等级",
    //   prop: 'zGrade',
    //   span: 8,
    //   labelWidth: 100,
    //   hide: true,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "电池容量",
    //   prop: 'zBattery',
    //   span: 8,
    //   labelWidth: 100,
    //   hide: true,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "通讯重连次数",
    //   prop: 'zLinkNum',
    //   labelWidth: 100,
    //   span: 8,
    //   hide: true,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "通讯重连时间",
    //   prop: 'zLinkTime',
    //   labelWidth: 100,
    //   span: 8,
    //   hide: true,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "报警时间/s",
    //   span: 8,
    //   prop: 'zAlarmTime',
    //   labelWidth: 100,
    //   hide: true,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "心跳时间/s",
    //   prop: 'zHeartTime',
    //   span: 8,
    //   labelWidth: 100,
    //   hide: true,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "欠压状态",
    //   prop: 'zStates',
    //   span: 8,
    //   labelWidth: 100,
    //   hide: true,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "电池欠压幅值",
    //   prop: 'zRange',
    //   span: 8,
    //   labelWidth: 100,
    //   hide: true,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "设置报警时间",
    //   prop: 'zSetTime',
    //   span: 8,
    //   labelWidth: 100,
    //   hide: true,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "设置电池欠压",
    //   prop: 'zSetStress',
    //   span: 8,
    //   labelWidth: 100,
    //   hide: true,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "设置心跳时间",
    //   prop: 'zSetHeartTime',
    //   labelWidth: 100,
    //   hide: true,
    //   span: 8,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "设置重连时间",
    //   prop: 'zSetLinkTime',
    //   span: 8,
    //   hide: true,
    //   labelWidth: 100,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "设置重连次数",
    //   prop: 'zSetLinkNum',
    //   span: 8,
    //   hide: true,
    //   labelWidth: 100,
    //   placeholder: '请输入 '
    // },
    {
      label: '设备描述',
      prop: "thirdDeviceDesc",
      overHidden: true,
      addDisplay: true,
      editDisplay: true,
      viewDisplay: true,
      span: 24,
      type: 'textarea',
      minRows: 3,
      maxlength: 200,
      rules: [{
        required: true,
        message: '请输入',
        trigger: 'blur'
      }]
    },
    ],
  }
}